import Vue from 'vue'
import { mapGetters } from 'vuex'
import { banks } from './constants'
import dayjs from 'dayjs'
require('dayjs/locale/th')

Vue.mixin({
  data() {
    return {
      bankList: banks,
      windowWidth: window.innerWidth,
    }
  },
  computed: {
    ...mapGetters(['']),
    $windowWidth() {
      return this.windowWidth
    },
  },
  created() {
    window.addEventListener('resize', this.onResize)
    this.onResize()
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth
    },
    $date(value) {
      if (value) {
        const date = dayjs(value).add(543, 'year')
        return  date.locale('th').format('DD MMM YY')
      }
      return ''
    },
    $displayStatusColor(status) {
      const val = status ? status.toLowerCase() : ''
      if (val === 'active') {
        return 'success'
      }
      if (val === 'blocked') {
        return 'danger'
      }
      if (val === 'inactive') {
        return 'dark'
      }
      return ''
    },
    $displayBankName(bankCode) {
      const found = this.bankList.find((item) => item.bank_code === bankCode)
      return found ? found.bank_name_th : bankCode
    },
    $allowPermission(permission) {
      switch (permission) {
        case 'credit':
        case 'settings':
          return true;
        default:
          return true
      }
    },
    $addPageToLocation(page) {
      history.pushState(
        {},
        null,
        `${this.$route.path}?page=${page}`
      )
    },
    $addPageQuery(queryKey, queryValue) {
      history.pushState({}, null, `${this.$route.path}?${queryKey}=${queryValue}`)
    },
    $navigateQueryToLocation(route, { query }) {
      const { key, value } = query;
      this.$router.push(`${route}?${key}=${value}`)
    },
  },
})
